// TanStack Query hooks for the console waitlist endpoints (/api/admin/leads). Master-only.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { LeadRead, LeadUpdate } from "./types";

export function useLeads() {
  return useQuery({
    queryKey: ["leads"],
    queryFn: () => apiFetch<LeadRead[]>("/api/admin/leads"),
  });
}

export function useUpdateLead(id: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: LeadUpdate) =>
      apiFetch<LeadRead>(`/api/admin/leads/${id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["leads"] });
    },
  });
}
